import { Tabs } from 'antd';
import { WorkflowDTOType } from '../../../../schemas';
import QCPendingItems from './QCPendingItems';
import QCPassedItems from './QCPassedItems';
import QCRejectedItems from './QCRejectedItems';
import TaggingPendingItems from './TaggingPendingItems';
import { useResponsiveTabsConfig } from '../../../../../shared/useResponsiveTabsConfig';

const ProductsTab = ({ workflow }: { workflow: WorkflowDTOType | null }) => {
  const { tabSize, tabBarGutter, tabAnimated } = useResponsiveTabsConfig();
  if (!workflow) {
    return null;
  }

  return (
    <Tabs
      defaultActiveKey="pending"
      items={[
        {
          key: 'pending',
          label: 'QC Pending Items',
          children: <QCPendingItems workflow={workflow} />,
        },
        {
          key: 'passed',
          label: 'QC Passed Items',
          children: <QCPassedItems workflow={workflow} />,
        },
        {
          key: 'failed',
          label: 'QC Failed Items',
          children: <QCRejectedItems workflow={workflow} />,
        },
        {
          key: 'processing',
          label: ' AI Tagging Pending',
          children: <TaggingPendingItems workflow={workflow} />,
        },
        // {
        //   key: 'testing',
        //   label: 'Test Data Creation',
        //   children: <TestDataCreationItems workflow={workflow} />,
        // },
      ]}
      size={tabSize}
      tabBarGutter={tabBarGutter}
      animated={tabAnimated}
      tabBarStyle={{
        marginBottom: 0,
        padding: '0 16px',
        position: 'sticky',
        top: 0,
        background: '#fff',
        zIndex: 1,
      }}
    />
  );
};

export default ProductsTab;
